import React, { useEffect, useState, useContext } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Deletemodel, Pagination, DocumentViewerModal } from '../../Common/Functions'

import {
  getDocumentsTable,
  apiClient,
  createDocumentsTable,
  getUsers,
  deleteDocumentsTable
} from "../../../Utility/Api";
import { toast } from "react-toastify";
import { WarehouseContext } from "../../../Utility/UserContext";
import { formatDate2, NaviGate, validateDates } from "../../../Utility/function";

const UserDocument = () => {
  const [document, setDocument] = useState(null);
  const [userDetails, setUserDetails] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [formData, setFormData] = useState({
    title: "",
    description: "",
    issued_date: "",
    file: null,
    expiry_date: "",
  });
  const [errors, setErrors] = useState({});
  const navigate = useNavigate();
  const { shopItem } = useContext(WarehouseContext);
  const [isDisabled, setIsDisabled] = useState(false);

  const [documentModal, setDocumentModal] = useState(false);
  const [DocumentUrl, setDocumentUrl] = useState('');

  const location = useLocation();
  const { userId } = location.state || {};
  console.log("userId", userId);
  useEffect(() => {
    if (userId) {
      // fetchUserDetails();
      fetchDocument();
    }
  }, [userId]);

  // Fetch User Details (Including Required IDs)
  const fetchUserDetails = async () => {
    try {
      const response = await getUsers(shopItem?.shop_id || "");
      if (response.data && response.data.data) {
        setUserDetails(response.data);
      }
    } catch (error) {
      console.error("Error fetching user details:", error);
      toast.error("Failed to fetch user details");
    }
  };

  // Fetch Document List
  const fetchDocument = async () => {
    try {
      const response = await getDocumentsTable(userId.user_Id);
      if (response.data && response.data.data) {
        setDocument(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching document:", error);
      toast.error("Failed to fetch document");
    }
  };

  const handleChange = (e) => {
    const { name, value, type, files } = e.target;

    if (type === "file") {
      setFormData({ ...formData, [name]: files[0] });
    } else {
      setFormData({ ...formData, [name]: value });
    }

    setErrors({});
  };

  const handleCancel = () => {
    setShowModal(false);
    setFormData({
      title: "",
      description: "",
      issued_date: "",
      file: null,
      expiry_date: "",
    });
  };

  const handleSubmit = async (e) => {
    if (isDisabled) return;

    e.preventDefault();
    const validationErrors = {};

    if (!formData.title) {
      validationErrors.title = "Title is required.";
    }
    if (!formData.file) {
      console.log("file")
      validationErrors.file = "Document file is required.";
    }
    if (!formData.issued_date) {
      validationErrors.issued_date = "Issued date is required.";
    }
    if (!formData.expiry_date) {
      validationErrors.expiry_date = "Expiry date is required.";
    }
    if (formData.issued_date && formData.expiry_date) {
      var error = validateDates(formatDate2(formData.issued_date), formatDate2(formData.expiry_date), 'issued', 'expiry',true);
      if (error) {
        toast.error(error);
        return;
      }
    }
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    setIsDisabled(true);

    const uploadData = new FormData();
    uploadData.append("title", formData.title);
    uploadData.append("description", formData.description);
    uploadData.append("file_upload", formData.file);
    uploadData.append("issued_date", formData.issued_date);
    uploadData.append("expiry_date", formData.expiry_date);
    uploadData.append("document_type_id", 1);
    uploadData.append("emp_id", userId.user_Id);
    uploadData.append("date", new Date().toISOString().split("T")[0]); // Current date
    uploadData.append("shop_id", userId.shop_id);
    

    try {
      await createDocumentsTable(uploadData);
      toast.success("Document uploaded successfully");
      setShowModal(false);
      fetchDocument();
      handleCancel();
    } catch (error) {
      console.error("Error uploading document:", error);
      toast.error("Failed to upload document");
    } finally {
      setIsDisabled(false);
    }
  };

  const Handledocumentview = (viewer) => {
    const Url = `http://193.203.162.101:8002/media/${viewer}`;
    setDocumentUrl(Url)
    setDocumentModal(true)
  }
  const [deleteID, setdeleteID] = useState("");
  const [deletemodel, showDeletemodel] = useState(false);

  
  const handleDelete = async () => {
    console.log("Deleting document with ID:", deleteID);
    try {
      await deleteDocumentsTable(deleteID);
      toast.success("Document deleted successfully");
      fetchDocument();
      showDeletemodel(false);
    } catch (error) {
      console.error("Error deleting document:", error);
      toast.error("Failed to delete document. Please try again.");
    }
  };
  
  

  const handledeletemodel = (Id) => {
    showDeletemodel(true);
    setdeleteID(Id);
  };

  return (
    <div className="container mt-4 pt-5">
      <div>
        <div>
          <NaviGate />
          <div className="d-flex justify-content-between mb-3">
            <h4>{userId.full_name}</h4>

            <button
              className="btn btn-primary"
              onClick={() => setShowModal(true)}
            >
              Upload Document
            </button>
          </div>
          <hr />

          <table className="table table-bordered">
            <thead>
              <tr>
                <th>S.No</th>
                <th>Title</th>
                <th>Description</th>
                <th>Issued Date</th>
                <th>Expire Date</th>
                <th>Document View</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {document?.map((doc, index) => (
                <tr key={doc.document_id}>
                  <td>{index + 1}</td>
                  <td>{doc.title}</td>
                  {/* <td>{doc.document_type_title || "N/A"}</td> */}



                  <td>{doc.description}</td>
                  <td>{doc.issued_date}</td>
                  <td>{doc.expiry_date}</td>
                  <td>
                    <button className="btn btn-primary" onClick={() => Handledocumentview(doc.file_upload)}>
                      <img src="assets/images/menu/document.png" alt='document' width={30} />
                    </button>
                  </td>
                  <td>
                    <img
                      src="/assets/images/icons/delete.png"
                      className="mx-1"
                      onClick={() => handledeletemodel(doc.document_id)}
                      height={"20px"}
                      alt=""
                      />
                  </td>

                </tr>
              )) || (
                  <tr>
                    <td colSpan="6">No documents available</td>
                  </tr>
                )}
            </tbody>
          </table>
        </div>
      </div>

      {/* Upload Document Modal */}
      {showModal && (
        <div
          className="modal fade show"
          style={{ display: "block" }}
          tabIndex="-1"
          role="dialog"
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Upload Document</h5>
                <button
                  type="button"
                  className="btn-close"
                  aria-label="Close"
                  onClick={() => setShowModal(false)}
                ></button>
              </div>
              <div className="modal-body">
                <form onSubmit={handleSubmit}>
                  <div className="form-group mb-3">
                    <label>Title</label>
                    <input
                      type="text"
                      name="title"
                      value={formData.title}
                      onChange={handleChange}
                      className="form-control"
                      required
                    />
                    {errors.title && (
                      <small className="text-danger">{errors.title}</small>
                    )}
                  </div>
                  <div className="form-group mb-3">
                    <label>Description</label>
                    <textarea
                      name="description"
                      value={formData.description}
                      onChange={handleChange}
                      className="form-control"
                      required
                    />
                  </div>
                  <div className="form-group mb-3">
                    <label>Issued Date
                    </label>
                    <div className="col-12">
                      <input
                        type="date"
                        name="issued_date"
                        value={formData.issued_date}
                        onChange={handleChange}
                        className="form-control"
                      />
                      {errors.issued_date && (
                        <small className="text-danger">{errors.issued_date}</small>
                      )}
                    </div>
                  </div>
                  <div className="form-group mb-3">
                    <label>Expiry Date</label>
                    <div className="col-12">
                      <input
                        type="date"
                        name="expiry_date"
                        value={formData.expiry_date}
                        onChange={handleChange}
                        className="form-control"
                      />
                      {errors.expiry_date && (
                        <small className="text-danger">{errors.expiry_date}</small>
                      )}
                    </div>
                  </div>
                  <div className="form-group mb-3">
                    <label>Upload Document</label>
                    <input
                      type="file"
                      name="file"
                      accept=".pdf, .doc, .docx, .xls, .xlsx"
                      onChange={handleChange}
                      className="form-control"
                      required
                    />
                    {errors.file && (
                      <small className="text-danger">{errors.file}</small>
                    )}
                  </div>

                  <button
                    type="submit"
                    className="btn btn-success float-end"
                    onClick={handleSubmit}
                    disabled={isDisabled}
                  >
                    {isDisabled ? "Uploading..." : "Upload"}
                  </button>

                  <button
                    type="button"
                    className="btn btn-secondary  float-end ml-2 me-3"
                    onClick={() => handleCancel()}
                  >
                    Cancel
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}

      {deletemodel && (
              <Deletemodel
                setShowModal={showDeletemodel}
                handleDelete={handleDelete}
              />
            )}

      {documentModal && (
        <DocumentViewerModal setShowModal={setDocumentModal} documentUrl={DocumentUrl} />
      )}
    </div>
  );
};

export default UserDocument;
